import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CurrentService } from '../../../services/current.service';
import { DatasService } from '../../../services/datas.service';
import { GTM } from 'src/app/services/gtm.service';
import { Router } from '@angular/router';
import { getHbmTotalSteps } from 'src/app/services/helpers/app-context-helper';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'ng-casto-kitchen-style',
  templateUrl: './style.component.html',
})
export class KitchenStyleComponent implements OnInit {
  @Output() onComplete: EventEmitter<void> = new EventEmitter();

  constructor(
    public current: CurrentService,
    public datas: DatasService,
    public gtm: GTM,
    private readonly router: Router,
    private readonly customer: CustomerService
  ) { }

  selectStyle(styleId: number) {
    if (this.current.kitchen.styleId !== styleId) {
      this.current.reset();
      this.current.kitchen.styleId = styleId;
    }
    this.onComplete.emit();
  }

  ngOnInit(): void {
    this.gtm.trackPage(`${this.router.url}/choix/ambiance`, 'Cuisine | Choix', {
      stepNumber: 1,
      totalSteps: getHbmTotalSteps(this.customer.context),
    });
  }
}
